import { shortId } from './shortId';

// Tipo de entidad del audit log (entityType del back) → etiqueta legible. Sin etiqueta, la clave.
export const AUDIT_TARGET_TYPE_LABELS: Record<string, string> = {
    Tenant: 'Organización',
    TenantUser: 'Usuario',
    PlatformUser: 'Usuario de plataforma',
    Role: 'Rol',
    RoleAssignment: 'Asignación de rol',
    Application: 'Aplicación',
    ApplicationPermission: 'Permiso de aplicación',
    LevelEntity: 'Entidad de nivel',
    SelfRegistration: 'Autorregistro',
    TenantAutoregister: 'Configuración de autorregistro',
    TenantUserField: 'Campo de usuario',
    TenantTypeCatalog: 'Catálogo de tipos de organización',
    SecurityPolicy: 'Política de seguridad',
    Branding: 'Marca',
};

export function auditTargetTypeLabel(type: string): string {
    return Object.prototype.hasOwnProperty.call(AUDIT_TARGET_TYPE_LABELS, type)
        ? AUDIT_TARGET_TYPE_LABELS[type]
        : type;
}

/** Recurso legible: «Tipo: nombre»; sin nombre, el id acortado como dato secundario. */
export function auditTargetLabel(type: string, id: string, name?: string): string {
    if (!type && !id) return '—';
    const typeLabel = type ? auditTargetTypeLabel(type) : 'Recurso';
    const cleanName = name?.trim();
    if (cleanName) return `${typeLabel}: ${cleanName}`;
    return id ? `${typeLabel} (ID ${shortId(id)})` : typeLabel;
}
